import { RefObject } from 'react';

// Lets distant UI (the chat tab strip) focus whichever chat input is mounted.
// The input's own focus ring doubles as the "here's your fresh chat" cue, so
// actions that land the user in a chat can make the input light up without any
// extra visual affordance.

let target: RefObject<HTMLTextAreaElement> | null = null;

export const registerChatInputFocusTarget = (
	ref: RefObject<HTMLTextAreaElement>
): (() => void) => {
	target = ref;
	return () => {
		if (target === ref) target = null;
	};
};

// Deferred a tick so an input mounted by the same click has registered first.
// An already-focused input re-focuses invisibly, so blink the ring instead —
// the "you're already in an empty chat" cue.
export const focusChatInput = () => {
	setTimeout(() => {
		const el = target?.current;
		if (!el) return;
		if (document.activeElement === el) {
			el.blur();
			setTimeout(() => el.focus(), 80);
		} else {
			el.focus();
		}
	}, 0);
};
